import React, { useEffect, useRef } from "react";
import "components/OtpSelector/OtpInputBox/OtpInputBox.css";

function OtpInputBox({ initRef, ...props }) {
  const ref = useRef(null);

  useEffect(() => {
    initRef(ref);
  });

  return <input className="otp-input__box " ref={ref} {...props} />;
}

export default OtpInputBox;
